<template>
  <div class="c-p-20">
    <div class="c-fl content">
      <div class="l">
        <img :src="src" alt="" srcset="" class="l-img" />
      </div>

      <div class="r">
        <slot>
          <div class="r-top">
            <div class="main-title">儿童票</div>
            <div class="sub-title">
              舒缓疲劳舒缓疲劳舒缓疲劳，舒缓疲劳。备份
            </div>
          </div>
          <div class="r-bottom">
            <div class="c-fl-bt">
              <div>
                <span class="change-color">￥88</span>
                <span class="origin-color">￥388.00</span>
              </div>
              <div>x3</div>
            </div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GImgList",
  props: {
    src: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.content {
  /* height: 200px; */
  .f {
    flex: 1;
  }
  .l-img {
    width: 130px;
    height: 130px;
    border-radius: 10px;
  }
  .r {
    flex: 2;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 180px;
    width: 100%;
  }
  .r-top {
    .main-title {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .sub-title {
      font-size: 22px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      margin-top: 20px;
    }
  }
  .r-bottom {
    .change-color {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--tc);
      margin-right: 10px;
    }
    .origin-color {
      font-size: 20px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      text-decoration: line-through;
    }
  }
}
</style>
